import { render } from "./audioModal.vue?vue&type=template&id=44ee1aa0&scoped=true"
import script from "./audioModal.vue?vue&type=script&lang=js"
export * from "./audioModal.vue?vue&type=script&lang=js"

import "./audioModal.vue?vue&type=style&index=0&id=44ee1aa0&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ee1aa0"]])

export default __exports__